import { JackpotCounterBuilder } from "./jackpotCounter/jackpotCounterBuilder";
import { JackpotWheelGame } from "./jackPotWheel/JackpotWheelGame";
// import { GameData } from "../gamestate/gameData";
// import * as $ from 'jquery';
import { JackpotIntroText } from "./jackPotWheel/jackpotIntroAnimation";
import {
  playJackpotMusic,
  displayJackpotBGCounter,
} from "./jackpotGlobalFunctions";
// import { convertCreditsFromServerToClient } from "../../common/datastructures/Credits";
// import { getParameterByName } from "../../common/getParameters";
import { CommonData } from "../datastructures/gamestate/gameData";
import { Howl } from "howler";
import DeviceChecker from "../functions/helper.ts/DeviceChecker";

// import { PopupMessageBox } from "../messageBox";
// import { disableAllBtns } from "../globalFunctions";
// // import Axios from "axios";
export interface jackpotResults {
  jackpotLevel: number;
  currentValue: {
    amount: number;
    currency: string;
  };
  timesWon: number;
  jackpotInstantiated: boolean;
  bigWinDateTime: string;
  bigWinValue: {
    amount: number;
    currency: string;
  };
  lastWinDateTime: string;
  lastWinValue: {
    amount: number;
    currency: string;
  };
  lastWinWinnerDisplayName: string;
}

export class jackPotManager {
  private parent: PIXI.Container;
  private counterContainer: PIXI.Container = new PIXI.Container();
  private introAnimation: JackpotIntroText;
  private activeGameData: CommonData;
  private animatedLabel: JackpotCounterBuilder;
  private game: JackpotWheelGame;
  private gameMask: PIXI.Graphics;
  private updateTicker: PIXI.ticker.Ticker;
  private initilized: boolean;
  private bgmusic: Howl;
  private winIndex: number;
  private jackpotOpen: boolean;
  private nextDataToDisplay: Array<jackpotResults>;
  private jackpotEnded: boolean;

  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    this.nextDataToDisplay = [];
    this.jackpotOpen = false;
    this.jackpotEnded = false;
    this.activeGameData = activeGameData;
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.gameMask = new PIXI.Graphics();
    this.gameMask.beginFill(0xff0000);
    this.gameMask.drawRect(
      0,
      0,
      this.activeGameData.size[0],
      this.activeGameData.size[1]
    );
    this.gameMask.endFill();
    this.parent.addChild(this.gameMask);
    //creates the label and jackpot game
    this.parent.addChild(this.counterContainer);
    this.animatedLabel = new JackpotCounterBuilder(
      this.counterContainer,
      this.activeGameData
    );
    this.game = new JackpotWheelGame(this.parent, this.activeGameData);
    // parent.addChild(this.parent);
    this.game.setMask(this.gameMask);
    this.initilized = false;
    this.introAnimation = new JackpotIntroText(
      this.parent,
      this.activeGameData
    );

    this.bgmusic = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/23265993_jackpotMusicLoop.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],
      volume: 1,
      sprite: {
        music: [0, 7666, true],
      },
    });
    this.activeGameData.bonusMusicList.push(this.bgmusic);

    let DateThen = Date.now();
    let updateDelta = 0;

    this.updateTicker = new PIXI.ticker.Ticker();
    this.updateTicker.stop();
    this.updateTicker.add(() => {
      //update jackpots number in x intervals
      if (Date.now() - DateThen > updateDelta) {
        this.updateAnimatedValueFromServer();
        DateThen = Date.now();
        if (updateDelta === 0) {
          updateDelta = 10000;
        }
      }
    });

    if (
      this.activeGameData.isDemo ||
      this.activeGameData.InspectReplay ||
      this.activeGameData.isTournament
      // || this.activeGameData.isEmulation
    ) {
      // hide the counters

      if (window.location.host != "localhost:8080") {
        this.setCounterVisible(false);
      }
    } else {
      //start the counter animation only when the game is not demo
      this.setCounterVisible(true);
      this.updateTicker.start(); //start doing the request to update the values
    }
    this.winIndex = 1; //default
    // this.parent.alpha=0;
  }
  public getUpdateTicker = (): PIXI.ticker.Ticker => {
    return this.updateTicker;
  };
  private intrepeteServerDataandSpin = (): void => {
    this.winIndex = this.activeGameData.jackpotContext.jackpotSpinWin.jackpotLevel;

    this.game.setWheelWinAndSpin(this.winIndex);
  };
  private updateDisplay = (): void => {
    if (this.initilized === false) {
      this.animatedLabel.setInitialValue(this.activeGameData.jackpotValuesData);
      this.initilized = true;
    } else {
      this.animatedLabel.setNewValues(this.activeGameData.jackpotValuesData);
    }
  };

  private updateAnimatedValueFromServer = (): void => {
    if (this.jackpotOpen == false) {
      var jackpotData = {
        operator: this.activeGameData.API_handler.getBrand(),
        gameReference: this.activeGameData.gameId,
        currency: "EUR",
      };

      let self = this;
      this.activeGameData.API_handler.GetJackpotResult(
        jackpotData,
        this.serverRequestSuccess.bind(self)
      );
    }
  };
  private disablejackpotCounters = (): void => {
    //if on the first response its not there then hide it by default
    console.log("--JACKPOT NOT AVAILABLE IN THIS GAME--");
    this.updateTicker.stop();
    this.animatedLabel.setJackpotIsEnabledForTheGame(false); //hide the from view to never show again
    ///hide the jackpot counters only
  };
  private serverRequestSuccess = (data: any): void => {
    if (data.length === 0) {
      this.disablejackpotCounters(); //never show jackpot after this
    } else {
      this.animatedLabel.setAvailable(true); //remove unvailable text and display the counters

      // if( this.parent.alpha==0){ this.parent.alpha=1};
      this.nextDataToDisplay = [];
      if (data) {
        if (this.nextDataToDisplay.length == 0) {
          // this.nextDataToDisplay=data
          this.assignDataInOrder(data);
        }
        this.activeGameData.jackpotResponse = this.nextDataToDisplay;
        this.copyAndCheckData();
        // this.nextDataToDisplay=data;//updates with new data

        this.activeGameData.jackPotGame.updateDisplay();
        this.assignDataInOrder(data); //

        this.animatedLabel.ServerResponseSuccess(true);
      }
      this.animatedLabel.setJackpotIsEnabledForTheGame(true);
    }
    ///-
  };
  private copyAndCheckData = (): void => {
    for (let i = 0; i < this.nextDataToDisplay.length; i++) {
      const data = this.nextDataToDisplay[i];
      if (data?.jackpotInstantiated != undefined) {
        //for new system where jackpotInstantiated is defined
        if (data?.jackpotInstantiated) {
          this.activeGameData.jackpotValuesData[i] = data.currentValue.amount;
        } else {
          this.animatedLabel.setAvailableIndex(data.jackpotLevel, false);
          this.activeGameData.jackpotValuesData[i] = 0;
          data.currentValue = {
            amount: 0,
            currency: this.activeGameData.currency,
          };
        }
      } else if (
        data?.jackpotInstantiated === undefined &&
        data.currentValue.amount
      ) {
        //for old system wher jackpotInstantiated wasnt defined
        this.activeGameData.jackpotValuesData[i] = data.currentValue.amount;
      }
    }
  };

  private assignDataInOrder = (data: any): void => {
    for (let i = 0; i < data.length; i++) {
      let lvl = data[i].jackpotLevel;
      switch (lvl) {
        case 1:
          this.nextDataToDisplay[0] = data[i];
          break;
        case 2:
          this.nextDataToDisplay[1] = data[i];
          break;

        case 3:
          this.nextDataToDisplay[2] = data[i];
          break;

        default:
          break;
      }
    }
  };

  public setCounterVisible = (bool: boolean): void => {
    this.animatedLabel.setVisibility(bool);
  };
  public setCounterParentVisible = (bool: boolean): void => {
    //used to overwrite the animatedLabel visibility control , for times when the jackpot counter are on top of blackscreenElement
    this.counterContainer.alpha = bool ? 1 : 0;
  };
  public setHighlightOnLabel = (listOfBox: Array<number>): void => {
    //not the counter of top button but inside game itself
    for (let i = 0; i < listOfBox.length; i++) {
      if (listOfBox[i] == 1) {
        this.game.setHighlight(true, i);
      } else {
        this.game.setHighlight(false, i);
      }
    }
  };
  public setMusicOn = (bool: boolean) => {
    if (bool) {
      this.bgmusic.play("music");
    } else {
      this.bgmusic.stop();
    }
  };
  public exitJackpot = (): void => {
    this.stop();
    this.game.setActiveAnimationIndex(1); //out animation
    this.jackpotOpen = false;

    this.updateAnimatedValueFromServer();
  };
  public getBlackBGContainer = (): PIXI.Graphics => {
    return this.game.getBlackBG();
  };

  public onResize = (): void => {
    let screenRatio = window.innerHeight / window.innerWidth;
    let isPortraitMode =
      this.activeGameData.playOnPortrait &&
      window.matchMedia("(orientation: portrait)").matches &&
      this.activeGameData.isMobile &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay;

    // let jackpotGameMainC=this.game.getParent();
    if (isPortraitMode) {
      this.game.setPortraitMode(true);
      let canvas = document.getElementsByTagName("canvas")[0];
      let scaleMultiplier =
        this.activeGameData.size[1] / this.activeGameData.gameResolution[1];
      this.gameMask.height = canvas.height * scaleMultiplier;
      this.game.getBlackBG().height = this.gameMask.height;
    } else {
      this.game.setPortraitMode(false);

      this.gameMask.height = this.activeGameData.size[1];
      this.game.getBlackBG().height = this.gameMask.height;
    }
  };
  public setJackpotBlackBGWidth(canvasWidth: number) {
    this.game.setBGWidth(canvasWidth);
  }

  public setCountersButtonVisible = (bool: boolean): void => {
    this.animatedLabel.setButtonMode(bool);
  };

  public setJackpotEnded = (bool: boolean): void => {
    this.jackpotEnded = bool;
  };
  public autoHideJackpotLabelOnPortrait = (): void => {
    //hides the label when the game have ended and result btn is shown on portrait mode , and display them back on landscape
    this.game.checkAutoHideLabelOnMobileOrientationChange();
  };
  public getJackpotEnded = (): boolean => {
    return this.jackpotEnded;
  };
  public launchJackpotIntro = (): void => {
    //intro animation text of jackpot
    displayJackpotBGCounter(this.activeGameData, false);
    this.game.setLabelValue(); //debug
    this.jackpotOpen = true;
    this.jackpotEnded = false;
    this.introAnimation.setInAnimations();
  };

  public setdebugData() {
    //--debug
    let fakeData = {
      jackpotValues: [
        { jackpotLevel: 3, currentValue: { amount: 732986, currency: "EUR" } },
        { jackpotLevel: 2, currentValue: { amount: 55477, currency: "EUR" } },
        { jackpotLevel: 1, currentValue: { amount: 2642, currency: "EUR" } },
      ],
      jackpotLevel: 2,
      credits: { amount: 55477, currency: "EUR" },
      currency: "EUR",
      jackpotSpinWin: {
        jackpotInstanceId: 77,
        jackpotLevel: 2,
        credits: { amount: 55477, currency: "EUR" },
        currency: "EUR",
      },
    };
    this.activeGameData.betResponse.jackpotContext = fakeData;
    this.activeGameData.jackpotContext = fakeData;
    //
  }
  public launchJackpot = (): void => {
    //launch the wheel
    // this.debugData()

    displayJackpotBGCounter(this.activeGameData, false);
    this.game.setActiveAnimationIndex(0); //in animation
    // this.serverRequest();
    playJackpotMusic(this.activeGameData, true);
    // showIngameJackpotCounter(this.activeGameData, false);

    if (this.activeGameData.replay.isOpen()) {
      this.game.setJackpotWheelCentered(true);
      // false
      this.setJackpotLabelsVisible(false);
    } else {
      this.game.setJackpotWheelCentered(false);
      this.setJackpotLabelsVisible(true); //resets
    }

    this.intrepeteServerDataandSpin();
  };

  public getIntroBlackBG = (): PIXI.Sprite => {
    return this.introAnimation.getBlackBG();
  };

  public isJackpotOpen = (): boolean => {
    // console.log(this.jackpotOpen,"JACKPOT OPEN?",this.parent.alpha)

    return this.jackpotOpen;
  };

  public stop = (): void => {
    if (this.jackpotOpen) {
      // console.log("close JACKPOT")
      //stop the intro
      this.introAnimation.clear();
      //stop the wheel
      this.game.stop();
      this.jackpotOpen = false;

      // return
      if (
        this.activeGameData.BuyBonus != undefined &&
        this.activeGameData.loginResponse.gameSettings != undefined &&
        this.activeGameData.loginResponse.gameSettings.buyBonusEnabled! !=
          undefined
      ) {
        // activeGameData.BuyBonusIsClientSideReady=false;
        this.activeGameData.BuyBonus.setHidden(false);
      }
    }
  };

  public setShineOnSelectedCounter = (index: number): void => {
    this.animatedLabel.setShineIndex(index);
  };

  public closeDetailsPanel = (): void => {
    this.animatedLabel.closepanel();
  };

  public setPortraitPlacement = (): void => {
    this.animatedLabel.setPortraitPosition();
  };

  public setJackpotLabelsVisible = (bool: boolean): void => {
    this.game.setLabelContainerVisible(bool);
  };
  public getParent = (): PIXI.Container => {
    return this.parent;
  };
}
